/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/ban-types */


import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ItineraryService } from '../shared/itinerary.service';
import { RestService } from '../shared/rest.service';
import { CountdownEvent } from 'ngx-countdown';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../pages/com.usblick.common/auth/user.service';
import { MaterialModalAlertComponent } from '../shared/material-modal-alert/material-modal-alert.component';
import { setting } from '../../../setting';
import * as moment from 'moment';
import { formPaxesReservationData, FormPaxesReservationData, routes } from './body-reservation/form-paxes-reservation/form-paxes-reservation-data';
import { HttpErrorResponse } from '@angular/common/http';
import { FormPaxesReservationComponent } from './body-reservation/form-paxes-reservation/form-paxes-reservation.component';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { hydrateOfflineDestinationInfo } from 'app/shared/itinerary-offline-destination';

@Component({
  selector: 'usb-itinerary-reservation',
  templateUrl: './itinerary-reservation.component.html',
  styleUrls: ['./itinerary-reservation.component.scss']
})

export class ItineraryReservationComponent implements OnInit {

  @ViewChild('formPaxesReservation') formPaxesReservation!: FormPaxesReservationComponent;

  from = 'total-reserve';
  step: any;
  itineraryId!: number;
  itineraryItems: any = [];
  itineraryClient: any;
  itinerary: any = [];
  paxes: any = [];
  _loading = true;
  formSended = false;
  buttonReserve: String = 'Next';
  nextStep: String = 'three';
  permitedConfiguration = true;
  paxesInItems: Array<any> = [];
  partialReserve = false;
  totalPrice: any = 0;
  valueArrItems: any;
  status: string;
  numberPosition!: number;
  totalAdults!: number;
  totalChildren!: number;
  clientSelecFormPaxes: any[] = [];
  currencies: any[] = [];
  currencyAgency: any;
  totalPasajeros: any;
  totalNights: any;
  totalDays: any;
  formPaxesReservationData: FormPaxesReservationData = formPaxesReservationData;
  loadedDataForm = false;
  countries: any[]= [];
  qtyAdults = 0;
  qtyChildrens = 0;
  loadingMiddle = false;
  paxesReload: any[] = [];
  onlyTransports = false;
  // @ViewChild(CountdownEvent) counter: CountdownEvent;

  public getClientsSettingAppBooking: any;

  config: any = {
    //format: "HH:mm:ss",
    template: '$!m!:$!s!',

    // format: 'm:s',
    size:'medium',
    //className:'clock-style'
  };

  verifyTimerPax(){
    if(this.paxes){
      if(this.paxes.length > 0){
        return this.paxes.length * 180;
      }else{
        return 0;
      }
    }else{
      return 0;
    }
  }

  constructor(
    private route: ActivatedRoute,
    private itineraryService: ItineraryService,
    private router: Router,
    public _restService: RestService,
    private dialog: MatDialog,
    public userService: UserService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {
     this.status = 'false';
     this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    }

  ngOnInit() {
    this.currencies = this.userService.currenciesExchange;
    // Cada reserva arranca enviando al proveedor los datos del pasajero
    this.userService.contactAgencyData = false;
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));

    // console.log('itineraryitems', this.itineraryItems);
    // console.log('itineraryActive ->', this.userService);

    this.currencyAgency = this.currencies.find(c => c.code === selectedAgency.currency);

    if(!this.currencyAgency) {
      this.router.navigateByUrl('home');
      this.notificationService.warning('Moneda no configurada en la agencia');
    }
    this._loading = true;

    // this.counter.begin();
    this.getActiveItinerary();
    this.getDocumentTypesList();
    this.getCountryData();
  }


  onFinished(event: CountdownEvent){

    if(event.action === 'done'){
      const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
        width: '450px',
        data: 'Tu tiempo ha expirado, volverás al resumen para verificar disponibilidad',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this._restService.setBooleanTimer(true);
          this.router.navigateByUrl('/summary');
        }
      });
    }



  }

  getActiveItinerary(){
    this.route.queryParams.subscribe(params => {
      this.from = (params['from']) ? params['from'] : 'total-reserve';
      this.step = (params['step']) ? params['step'] : 'two';

      this.userService.from = (params['from']) ? params['from'] : 'total-reserve';
      // this.userService.stepReservation = (params["step"]) ? params["step"] : 'two';

      this.partialReserve = (this.from=='partial-reserve') ? true : false;
      this.itineraryId = (params['itineraryId']) ? params['itineraryId'] : null;

    });

    switch (this.step) {
      case 'two':
        this.buttonReserve = 'Next';
        this.nextStep = 'three';
        break;
      case 'three':
        this.buttonReserve = 'Reserve';
        this.nextStep = 'four';
        break;
      default:
        this.buttonReserve = 'Next';
        this.nextStep = 'three';
        break;
    }
    this.getItineraryInfo();
  }


  getItineraryInfo(reloadPaxlist?: boolean) {
    setTimeout(() => {
        if (this.itineraryId) {
            this._restService.doGet('app', 'itineraries/' + this.itineraryId).subscribe((response: any) => {


            if(reloadPaxlist) {
              this.paxesReload = response.data.paxList;
            } else {
              this.userService.itineraryActive[0] = response.data;
              const products = [];
              response.data.items.forEach(element => {
                // "Web Offline Request" = ítems cotizados a partir de una solicitud offline.
                // Antes el filtro solo dejaba "Web", por lo que un hotel offline no aparecía
                // en el resumen de la reserva. Se incluye explícitamente.
                if (element.status_id == 1 && (element.source === 'Web' || element.source === 'Web Offline Request') ) {
                  products.push(element);
                }
              });

              // ===== FIX PROVISORIO — ITEMS OFFLINE REQUEST =====
              // Los items con source = "Web Offline Request" NO vienen con:
              //   - itinerary.destination[] poblado
              //   - item.destination.destination_info poblado
              // Eso rompe summary-reservation.component.ts y otros que esperan esa
              // estructura. Se hidrata acá en el front con lo que sí trae el item.
              // BORRAR cuando el backend popule estos campos en itinerarios con
              // items "Web Offline Request".
              hydrateOfflineDestinationInfo(response.data, products);
              // ===== FIN FIX PROVISORIO =====

              this.itinerary = response.data;

              this.itineraryItems = (this.partialReserve == false) ? products : this.getItemsPartial(products);

              if(this.itineraryItems && this.itineraryItems.length > 0) {
                const itineraryItemsOnlyTransports = this.itineraryItems.every(c => c.category_id === 8);
                this.onlyTransports = itineraryItemsOnlyTransports;
              }


              this.getPaxesQty();
              this.totalNights = this.getTotalNights();
              this.totalDays = this.totalNights + 1;
              this.totalPrice =  this.itinerary.totalNetPriceBooking;
              this.paxes = this.setArrayPaxes(this.itinerary);
              this.restoreContactProviderData();
              this.permitedConfiguration = this._permitedConfiguration(this.itineraryItems);
              this.itineraryItems = this.itineraryItems.sort((a, b) => this.convertDates(a.arrivalDate) - this.convertDates(b.arrivalDate));
              this.config.leftTime = setting.defauldTimeBooking * 60;
              this._loading = false;
            }


          }, error => {
            console.log('Error: ' + error);
          });
        } else {
          this.itineraryService.activeItinerary.subscribe((data: any) => {
            if (data !== undefined && data!==true) {
              this.itinerary = data[0];
              console.log('[reservation][DBG] items crudos del itinerary:', data[0].items?.map(i => ({ id: i.id, source: i.source, status_id: i.status_id, category: i.category_id, name: i.title })));
              this.itineraryItems = (this.partialReserve == false) ? data[0].items : this.getItemsPartial(data[0].items);
              console.log('[reservation][DBG] items después de partial/total:', this.itineraryItems?.map(i => ({ id: i.id, source: i.source, status_id: i.status_id })));
              if(!this.partialReserve) {
                // "Web Offline Request" = ítems cotizados a partir de una solicitud offline.
                // Antes el filtro solo dejaba "Web", por lo que un hotel offline no aparecía
                // en el resumen de la reserva. Se incluye explícitamente.
                this.itineraryItems = this.itineraryItems.filter(c => c.source === 'Web' || c.source === 'Web Offline Request');
              }

              // ===== FIX PROVISORIO — ITEMS OFFLINE REQUEST =====
              // (Ver bloque al inicio de getItineraryInfo para el detalle.)
              hydrateOfflineDestinationInfo(data[0], this.itineraryItems);
              // ===== FIN FIX PROVISORIO =====

               this.getPaxesQty();
               this.totalNights = this.getTotalNights();
               this.totalDays = this.totalNights + 1;
              this.totalPrice =  this.itinerary.totalNetPriceBooking;
              this.paxes = this.setArrayPaxes(this.itinerary);
              this.restoreContactProviderData();
              this.permitedConfiguration = this._permitedConfiguration(this.itineraryItems);
              this._loading = false;
              this.config.leftTime = setting.defauldTimeBooking * 60;
               this._loading = false;
            }
          });
        }
      }, 500);
  }

  /**
   * Recupera "Datos de contacto a enviar al proveedor" guardado en los items de la reserva
   * (contact_agency_data, se guarda en todos al elegirlo): se toma del primero.
   */
  private restoreContactProviderData(): void {
    const value = this.itineraryItems?.[0]?.contact_agency_data;
    this.userService.contactAgencyData = [true, 1, '1', 'true'].includes(value);
  }

  getPaxesQty(): void {
        if (this.itineraryItems && Array.isArray(this.itineraryItems) && this.itineraryItems.length > 0) {

              this.totalAdults = this.itineraryItems.reduce((sum, item) => sum + (item.paxAdults || 0), 0);
              this.totalChildren = this.itineraryItems.reduce((sum, item) => sum + (item.paxChildren || 0), 0);

        }


  }


getTotalNights(): number {
    if (!this.itineraryItems || !Array.isArray(this.itineraryItems)) {
        return 0;
    }

// FILTRAR solo items con category_id === 1 o 4 (alojamiento y parques)
    const filteredItems = this.itineraryItems.filter(item => (item.category_id === 1 || item.category_id === 4));

    // Si no hay items con category_id 1 o 4, retornar 0
    if (filteredItems.length === 0) {
        return 0;
    }

    const dateRanges = filteredItems.map(item => ({
        start: moment(item.arrivalDate),
        end: moment(item.departureDate)
    }));

    // Ordenar por fecha de inicio
    dateRanges.sort((a, b) => a.start.diff(b.start));

    // Consolidar intervalos
    const consolidated = [];
    let current = dateRanges[0];

    for (let i = 1; i < dateRanges.length; i++) {
        const next = dateRanges[i];

        if (next.start.isSameOrBefore(current.end)) {
            if (next.end.isAfter(current.end)) {
                current.end = next.end;
            }
        } else {
            consolidated.push(current);
            current = next;
        }
    }
    consolidated.push(current);

    // Sumar noches
    return consolidated.reduce((total, range) => total + range.end.diff(range.start, 'days'), 0);
}

  convertDates(fechaString): any{
    const fechaSp = fechaString.split('-');
    let anio = new Date().getFullYear();
    if (fechaSp.length == 3) {
      anio = fechaSp[0];
    }
    const mes = fechaSp[1] - 1;
    const dia = fechaSp[2];

    return new Date(anio, mes, dia);
  }

  getItemsPartial(items): any {
    const itemsPartial: any = [];
    items.forEach(item => {
      if(item.partial_selected==1){
        itemsPartial.push(item);
      }
    });

    return itemsPartial;
  }


  _permitedConfiguration(items): boolean{
    const status = true;
    return status;
  }

  getItineraryInfoReserve(){
    if(this.itineraryId){
      this._restService.doGet('app','itineraries/' + this.itineraryId).subscribe((response: any) => {
        this.itinerary = response;
          this.itinerary = response.data;
          this.makeReserve();
      }, error => {
        console.log('Error: ' + error);
      });
    } else {
      this.itineraryService.activeItinerary.subscribe((data: any) => {
        if (data !== undefined){
          this.itinerary = data[0];
          this.makeReserve();
        }

      });
    }
  }



getChildrenAgesWithDate(items: any): { age: number; arrivalDate: Date; arrivalDateString: string}[] {
  const result: { age: number; arrivalDate: Date; arrivalDateString: string }[] = [];


  // ✅ Contar cuántos firstWay 1 y firstWay 2 hay
  const firstWay1Items = items.filter(i => i.category_id === 8 && i.firstWay === 1);
  const firstWay2Items = items.filter(i => i.category_id === 8 && i.firstWay === 2);


  // ✅ Determinar qué firstWay procesar
  // Si hay firstWay1 y firstWay2, solo procesar firstWay1 (ida y vuelta simplificado)
  const processFirstWay1 = firstWay1Items.length > 0;
  const processFirstWay2 = firstWay2Items.length > 0 && firstWay1Items.length === 0;


  for (const item of items) {
    // ✅ Saltar firstWay2 si también hay firstWay1 (ida y vuelta simplificado)
    if (item.category_id === 8 && item.firstWay === 2 && firstWay1Items.length > 0) {
      continue;
    }

    // ✅ Saltar firstWay1 si no hay ninguno (no debería pasar)
    if (item.category_id === 8 && item.firstWay === 1 && firstWay1Items.length === 0) {
      continue;
    }

    const currentDateStr = new Date().toISOString().split('T')[0];
    const categoryId = item.category_id;
    let payloadUpdate;
    let arrivalDate: Date | null = null;

    if (item.arrivalDate) {
      arrivalDate = this.normalizeDate(currentDateStr);
    }

    if (!arrivalDate) {
      arrivalDate = this.normalizeDate(item.dateIni);
    }

    if (!arrivalDate) {
      console.warn(`Item ${item.id} sin fecha de llegada`);
      continue;
    }

    if (item.category_id === 8) {
      payloadUpdate = item.payloadSync;
    } else {
      payloadUpdate = item.payloadUpdate;
    }

    if (item.category_id !== 8 && (!payloadUpdate || !payloadUpdate.products || payloadUpdate.products.length === 0)) {
      continue;
    }

    if (item.category_id === 8 && !payloadUpdate) {
      continue;
    }

    let ages: number[] = [];
    switch (categoryId) {
      case 4: // PARQUES TEMATICOS (mismo formato que alojamiento)
      case 1: // HOTELES
        const roomConfigurations = payloadUpdate.products[0]?.others?.hotels?.roomConfiguration;
        if (roomConfigurations && Array.isArray(roomConfigurations)) {
          for (const room of roomConfigurations) {
            if (room.children && Array.isArray(room.children)) {
              ages.push(...room.children.map((age: any) => Number(age)));
            }
          }
        }
        break;

      case 2: // RENT A CAR
        const rentAcarChildren = payloadUpdate.childAge;
        if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
          ages = rentAcarChildren.map((age: any) => Number(age));
        }
        break;

      case 6: // TOURS / EXPERIENCIAS
        const tourChildren = payloadUpdate.products[0]?.others?.tours?.children;
        if (tourChildren && Array.isArray(tourChildren)) {
          ages = tourChildren.map((age: any) => Number(age));
        }
        break;

      case 8: // TRANSPORTS / TRASLADOS
        const transferChildren = payloadUpdate.transfers?.paxList?.children;
        if (transferChildren && Array.isArray(transferChildren)) {
          ages = transferChildren.map((age: any) => Number(age));
        }
        break;

      case 9: // TICKETS
        const ticketChildren = payloadUpdate.products[0]?.others?.tours?.children;
        if (ticketChildren && Array.isArray(ticketChildren)) {
          ages = ticketChildren.map((age: any) => Number(age));
        }
        break;

      case 10: // ASISTENCIA / PAQUETES
        ages = this.getInsurancePaxAges(payloadUpdate).filter(age => age < 18);
        break;
    }



    for (const age of ages) {
      result.push({
        age,
        arrivalDate,
        arrivalDateString: currentDateStr
      });
    }
  }


  return result;
}

/**
 * Edades de los pax de una asistencia (category_id 10).
 * paxList puede venir como array (payload de búsqueda) o como objeto (payloadUpdate).
 */
private getInsurancePaxAges(payloadUpdate: any): number[] {
  const paxList = payloadUpdate?.products?.[0]?.insurances?.paxList;
  const paxAges = Array.isArray(paxList) ? paxList[0]?.paxAges : paxList?.paxAges;

  return Array.isArray(paxAges) ? paxAges.map((age: any) => Number(age)) : [];
}

/**
 * Edades de adultos (>= 18) requeridas por las asistencias del itinerario.
 * Con varias asistencias se toma, por cada edad, la mayor cantidad pedida por
 * alguna de ellas (un mismo adulto puede viajar en todas).
 * Usa la misma fecha de referencia que getChildrenAgesWithDate.
 */
getAdultsAgesWithDate(items: any): { age: number; arrivalDate: Date; arrivalDateString: string }[] {
  const maxCountByAge = new Map<number, number>();

  (items || [])
    .filter(item => item.category_id === 10 && item.payloadUpdate)
    .forEach(item => {
      const countByAge = new Map<number, number>();
      this.getInsurancePaxAges(item.payloadUpdate)
        .filter(age => !isNaN(age) && age >= 18)
        .forEach(age => countByAge.set(age, (countByAge.get(age) || 0) + 1));

      countByAge.forEach((count, age) => {
        if (count > (maxCountByAge.get(age) || 0)) {
          maxCountByAge.set(age, count);
        }
      });
    });

  const currentDateStr = new Date().toISOString().split('T')[0];
  const arrivalDate = this.normalizeDate(currentDateStr) as Date;
  const result: { age: number; arrivalDate: Date; arrivalDateString: string }[] = [];

  maxCountByAge.forEach((count, age) => {
    for (let i = 0; i < count; i++) {
      result.push({ age, arrivalDate, arrivalDateString: currentDateStr });
    }
  });

  return result;
}

private normalizeDate(dateStr: string, subtractOneDay: boolean = true): Date | null {

  if (!dateStr) {
return null;
}

  const parts = dateStr.split('T')[0].split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  const date = new Date(Date.UTC(year, month, day, 12, 0, 0));

  if (subtractOneDay) {
    date.setUTCDate(date.getUTCDate() - 1);
  }

  return date;
}


setArrayPaxes(itinerary): Array<any> {
  this.paxes = [];
  let totalAdults = 0;
  let totalChildren = 0;
  let maxAdults = 0;
  let maxChildren = 0;

  const partialItems = this.itinerary.items.some(c => c.partial_selected === 1);
  let items = partialItems ? this.itinerary.items.filter(c => c.partial_selected === 1)?.filter(c => c.status_id === 1) : [];

  if(items.length === 0) {
  items = this.itinerary.items.filter(c => c.status_id === 1) || [];
  }

  const paxList = this.itinerary.paxList || [];

  // ✅ Obtener edades CON su fecha de llegada

  const childrenWithDates = this.getChildrenAgesWithDate(this.itineraryItems);

  const childrensFormInitial = this.getChildrenAgesWithDate(this.itineraryItems);

  // Edades de adultos exigidas por las asistencias (vacío si no hay category_id 10)
  const adultsWithDates = this.getAdultsAgesWithDate(this.itineraryItems);

  if (items?.length) {
    items.forEach(item => {
      const adultsNum = Number(item.paxAdults) || 0;
      const childrenNum = Number(item.paxChildren) || 0;

      maxAdults += adultsNum;
      maxChildren += childrenNum;

      if (adultsNum > totalAdults) {
        totalAdults = adultsNum;
      }

      if (childrenNum > totalChildren) {
        totalChildren = childrenNum;
      }
    });


    // ✅ Crear array de pasajeros con el tamaño correcto
    this.createPassengerArray(totalAdults, childrensFormInitial.length);

    const existingPaxKeys = new Set(
      this.paxes.map(pax => `${pax.type}_${pax.first_name || ''}_${pax.last_name || ''}`)
    );

      const paxOptional = paxList.filter(pax => {
        if (!pax?.paxOptional) {
return false;
}
        const paxKey = `${pax.type}_${pax.first_name || ''}_${pax.last_name || ''}`;
        return !existingPaxKeys.has(paxKey);
      });

      paxOptional.forEach(pax => {
        this.paxes.push({
          title: `${pax.first_name ? pax.first_name : pax.type === 'adult' ? 'Adulto' : 'Niño'} ${pax.last_name ? pax.last_name : ''}`,
          type: pax.type,
          number: this.paxes.length + 1,
          isOptional: true,
          age: null,
          arrivalDate: null
        });

        totalAdults = totalAdults + 1;

      });

      this.qtyAdults = totalAdults;
      this.qtyChildrens = childrensFormInitial.length;

    // ✅ Asignar edades con su fecha de llegada a los niños y, si hay asistencias,
    // a los adultos. ageIndex es la posición en childrenWithDates / adultsWithDates.
    let childIndex = 0;
    let adultIndex = 0;
    this.paxes.forEach((pax: any) => {
      const isChild = pax.type === 'children';
      const agesWithDates = isChild ? childrensFormInitial : adultsWithDates;
      const index = isChild ? childIndex : adultIndex;

      if (agesWithDates[index]) {
        pax.age = agesWithDates[index].age;
        pax.arrivalDate = agesWithDates[index].arrivalDate;
        pax.arrivalDateString = agesWithDates[index].arrivalDateString;
        pax.ageIndex = index;
        if (isChild) {
          childIndex++;
        } else {
          adultIndex++;
        }
      } else {
        pax.age = null;
        pax.arrivalDate = null;
        pax.arrivalDateString = null;
        pax.ageIndex = null;
      }
    });

    this.reorderPaxesByType();

    this.totalPasajeros = {
      maxAdults,
      adults: totalAdults,
      niños: totalChildren,
      childs: totalChildren,
      maxChildren,
      total: maxAdults + maxChildren,
      paxes: this.paxes,
      childrenWithDates,
      adultsWithDates
    };

    return this.paxes;
  }

  return [];
}


  /**
   * Reordena los paxes para que los adultos queden primero,
   * luego los niños, y finalmente los opcionales
   * Además reasigna los números de orden
   */
reorderPaxesByType(): void {
  // Separar por tipo y prioridad
  const adults = this.paxes.filter(pax => pax.type === 'adult' && !pax.isOptional);
  const children = this.paxes.filter(pax => pax.type === 'children' && !pax.isOptional);
  const optionalAdults = this.paxes.filter(pax => pax.type === 'adult' && pax.isOptional);
  const optionalChildren = this.paxes.filter(pax => pax.type === 'children' && pax.isOptional);

  // Reordenar: Adultos normales > Niños normales > Adultos opcionales > Niños opcionales
  this.paxes = [...adults, ...children, ...optionalAdults, ...optionalChildren];

  // Reasignar números de orden
  this.paxes.forEach((pax, index) => {
    pax.number = index + 1;

    // Actualizar título si es necesario
    if (!pax.isOptional) {
      if (pax.type === 'adult') {
        const adultIndex = adults.findIndex(a => a === pax) + 1;
        pax.title = `Adulto ${adultIndex}${adultIndex === 1 ? ' - Titular' : ''}`;
      } else if (pax.type === 'children') {
        const childIndex = children.findIndex(c => c === pax) + 1;
        pax.title = `Niño ${childIndex}`;
      }
    }
  });
}

  createPassengerArray(adults: number, children: number) {

    this.paxes = [];

    // Adultos
    for (let i = 1; i <= adults; i++) {
      this.paxes.push({
        title: `Adulto ${i}${i === 1 ? ' - Titular' : ''}`,
        type: 'adult',
        number: i,
      });
    }

    // Niños
    for (let i = 1; i <= children; i++) {
      this.paxes.push({
        title: `Niño ${i}`,
        type: 'children',
        number: adults + i,
      });
    }
  }

private groupNonOverlappingDates(hotelItems: any[]): any[][] {
  const groups: any[][] = [];

  const sortedItems = [...hotelItems].sort((a, b) =>
    new Date(a.arrivalDate).getTime() - new Date(b.arrivalDate).getTime()
  );

  let currentGroup: any[] = [];

  sortedItems.forEach((item, index) => {
    if (currentGroup.length === 0) {
      currentGroup.push(item);
    } else {
      const lastItem = currentGroup[currentGroup.length - 1];
      const lastDeparture = new Date(lastItem.departureDate);
      const currentArrival = new Date(item.arrivalDate);

      // Si HAY superposición (mismo día o fechas que se solapan)
      if (currentArrival < lastDeparture) {
        currentGroup.push(item);
      } else {
        // Si NO hay superposición - guardar grupo actual y empezar nuevo
        groups.push([...currentGroup]);
        currentGroup = [item];
      }
    }
  });

  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
}

  goNextStep(){
    if(this.nextStep=='four'){
      // reservar
     // console.log('reserva==>', this.paxesInItems);

      //buscar los paxes registrados para comparar
      this.getItineraryInfoReserve();


    } else {
      const navigationExtras: NavigationExtras = {
        queryParams: {
            from: this.from,
            step: this.nextStep
        }
      };

      this.router.navigate(['itinerary-reservation'], navigationExtras);
    }
  }

  makeReserve() {
    //console.log("item para reserva==>",this.itineraryItems);
    //console.log("paxes en itinerario==>",this.itinerary.paxList);
    //console.log("paxes seteados==>",this.paxesInItems);
  }

  onChange(paxes: any){
    //console.log('del hijo al padre==>',paxes);
    this.paxesInItems = paxes;
    // paxes.forEach(i => {
    //   this.paxesInItems.push(i);
    // });
  }

  existHotel(){
    if(this.userService.itineraryActive.length > 0){
      if(this.userService.itineraryActive[0].items.length>0){
        const exist = this.userService.itineraryActive[0].items.find( element => (element.categoryName == 'HOTELS' || element.categoryName == 'PARKS') );

        if(exist){
          return true;
        }else{
          return false;
        }
      }
    }
  }

  clientSelectedArr(clientSelectFormPaxes: any[]) {
    this.clientSelecFormPaxes = clientSelectFormPaxes;
  }

  getDocumentTypesList(i?: number): void {

  this.itineraryService._restService.doGet(routes.app, routes.document_type)
    .subscribe({
      next: (res: any) => {
        if(res && res.length > 0) {
          this.formPaxesReservationData.documentTypes = res;
          this.formPaxesReservationData.documentTypes = this.formPaxesReservationData.documentTypes.filter(c => c.id === 4 || c.id === 5);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
}

  getCountryData(): void {
    this.itineraryService._restService.doGet(routes.app, routes.countries)
        // .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (response: any) => {
            this.countries = response['Countrys'];
            this.loadedDataForm = true;
          },
          error: (error: HttpErrorResponse) => {
            console.log(error);
          }
        });
  }

  valueQtyPaxModifiedFx(event: any): void {
    switch(event.type) {
      case 'children':
          if(event.sum) {
            this.qtyChildrens++;
          } else {
            this.qtyChildrens--;
          }
        break;
      case 'adult':
         if(event.sum) {
            this.qtyAdults++;
          } else {
            this.qtyAdults--;
          }
        break;
    }
  }

  getStep(step: string): boolean {

    if(step) {
      if(step === 'three') {
        this.loadingMiddle = false;
      }
      return this.userService.stepReservation === step;
    }

  }

  proccessPaxesFormData(show?: boolean): void {
    // El form emite sin valor al enviar y emit(false) si el backend rechaza el paxList
    this.loadingMiddle = show !== false;
    this.cdr.detectChanges();
  }

  reloadPaxlist(): void {
    this.getItineraryInfo(true);
  }

}
